import o from"styled-components";var t=o("tbody").withConfig({componentId:"sc-c7cniy-0"})(["display:block;min-width:fit-content;"]);export{t as TBody};
